import { Injectable, Optional } from '@angular/core';
import { LanguageService } from './language.service';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { mergeMap, map, filter, tap } from 'rxjs/operators';
import { StorageService } from '../storage/storage.service';


@Injectable()
export class LangInterceptorService implements HttpInterceptor {

  constructor(@Optional() private storage: StorageService) {

  }
  async expect(request: HttpRequest<any>, next: HttpHandler) {
    if(this.storage){
    const lang = await of(this.storage.getLang()).pipe(filter(a => a !== undefined)).toPromise();
    if(this.storage.getLang().LangID !== undefined){
      const requestClone = request.clone({
        setParams: {
          LangID: this.storage.getLang().LangID as string
        }
      });
      return next.handle(requestClone).toPromise();
    }
    else{
      return next.handle(request).toPromise();
    }

  }else{
    return next.handle(request).toPromise();
  }

  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.indexOf('RB-LANGUAGES') > -1) {
      return next.handle(request);
    }
    this.storage.loading=true;
    return Observable.fromPromise(this.expect(request, next)).pipe(tap(a=>this.storage.loading=false));

  }
}
